import Infra from './Infra'
import InfraDependencies from './InfraDependencies'

export default new Infra(InfraDependencies)
